export default __webpack_public_path__ + "static/media/Photo 2 - BR - feuillage persistant nord.f30eaf89.png";